module.exports = __webpack_public_path__ + "img/3_Bericht_Sonst_Stehzeit.2c3a9f6c.svg";